import React from 'react';
import { IconBaseProps } from 'react-icons';

import { ReactComponent as SecurityCameraIcon } from './security-camera.svg';

export default function FarmbotSecurityCameraIcon({ size, ...props }: IconBaseProps) {
  return (
    <SecurityCameraIcon
      width={size || 18}
      height={size || 18}
      {...props}
    />
  );
}
